import { Point } from "ol/geom";
import { transform } from "ol/proj";
import { Feature, Map } from "ol";
import { copyMarkerStyle, goToYandexMirrorsMarkerStyle } from "../../styles/mapStyles";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { store } from "../../../../../stateManagement/store";
import { setCopyCoordsButtonIsClicked, setCopyCoordsTypeIsChosen } from "../../../../../stateManagement/reducers/ContentHeaderSlice";
import { showToastMessage } from "../../../../../stateManagement/reducers";

type CoordinateFormatters = {
    decimal: (coordinates: [number, number] | [number, number, number]) => string;
    degrees: (coordinates: [number, number] | [number, number, number]) => string;
    wktCoord: (coordinates: [number, number] | [number, number, number]) => string;
};

// Объект с функциями форматирования
export const coordinateFormatters = {
    decimal: (coordinates: any) => coordinates.reverse().map((coord: any) => coord.toFixed(15)).join(', '),
    degrees: (coordinates: any) => {
        const dmsCoordinates = coordinates.reverse().map((coord: any) => {
            const absolute = Math.abs(coord);
            const degrees = Math.floor(absolute);
            const minutesNotTruncated = (absolute - degrees) * 60;
            const minutes = Math.floor(minutesNotTruncated);
            const seconds = (minutesNotTruncated - minutes) * 60;
            return `${degrees}° ${minutes}' ${seconds.toFixed(4)}" ${coord >= 0 ? 'N' : 'S'}`;
        });
        return dmsCoordinates.join(', ');
    },
    wktCoord: (coordinates: any) => {
        return `POINT(${coordinates.map((coord: any) => coord.toFixed(7)).join(' ')})`;
    }
};

export function moveMarkerFunction(event: any, markerFeature: any) {
    const coordinates = event.coordinate;
    const geometry = new Point(coordinates);
    markerFeature.setGeometry(geometry);
}

export function copyPointCoordinatesFunction(event: any, coordsType: keyof CoordinateFormatters, markerSource: any) {
    const coordinates = transform(event.coordinate, 'EPSG:3857', 'EPSG:4326');
    const formatFunction = coordinateFormatters[coordsType];
    if (formatFunction) {
        const formattedCoordinates = formatFunction(coordinates);
        navigator.clipboard.writeText(formattedCoordinates)
            .then()
            .catch(error => {
                console.error('Ошибка копирования координат:', error);
            });
    }
    store.dispatch(setCopyCoordsButtonIsClicked(false))
    store.dispatch(setCopyCoordsTypeIsChosen(false))
    store.dispatch(showToastMessage({ messageText: 'Координаты скопированы в буфер обмена', messageType: "info", windowType: "map" }))
    markerSource.clear();
}

// Функция копирования координат в точке на карте
export function activateCopyPointCoordinates(isCopyButtonTypeChosen: boolean, copyCoordsButtonIsClicked: boolean, map?: Map) {
    const markerFeature = new Feature();
    const coordsType: any = store.getState().map.coordsType
    const dispatch = store.dispatch
    markerFeature.setStyle(copyMarkerStyle);
    const markerSource = new VectorSource({
        features: [markerFeature],
    });
    const markerLayer = new VectorLayer({
        zIndex: 6000,
        source: markerSource,
    });
    const newMarkerFunction: any = (event: any) => copyPointCoordinatesFunction(event, coordsType, markerSource)
    const newMoveMarkerFunction: any = (event: any) => moveMarkerFunction(event, markerFeature)
    // Вешаем на карту слушатель нажатия для копирования
    if (isCopyButtonTypeChosen && copyCoordsButtonIsClicked) {
        map?.addLayer(markerLayer)
        map?.on('pointermove', newMoveMarkerFunction);
        map?.on('singleclick', newMarkerFunction)
    }
    return {
        off: () => {
            map?.removeLayer(markerLayer);
            map?.un('pointermove', newMoveMarkerFunction);
            map?.un('singleclick', newMarkerFunction);
            if (!copyCoordsButtonIsClicked) {
                dispatch(setCopyCoordsTypeIsChosen(false))
            }
        }
    }
}